import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import makeStyles from "@material-ui/styles/makeStyles";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Radio from "@material-ui/core/Radio";

import ImageEye from "@material-ui/icons/RemoveRedEye";

import { toFixed } from "../../utils/helpers";

const useStyles = makeStyles({
  table: {
    "& th, & td": {
      border: "1px solid rgba(224, 224, 224, 1)"
    },
    whiteSpace: "pre"
  },
  fixedHeader: {
    position: "sticky",
    top: 0,
    backgroundColor: "white"
  },
  link: {
    color: "blue",
    cursor: "pointer"
  }
});

const GroupOptionsTable = props => {
  const classes = useStyles();
  const { id, columns, groupOptions, fixedHeader, type, handleSelection, onDeviationClick, onViewClick } = props;

  return (
    <MuiTable className={classes.table} id={id}>
      <TableHead>
        <TableRow>
          <TableCell align="center" className={classnames({ [classes.fixedHeader]: fixedHeader })}>
            Selector
          </TableCell>
          <TableCell align="center" className={classnames({ [classes.fixedHeader]: fixedHeader })} style={{ width: "8%" }}>
            Serial No.
          </TableCell>
          {columns.map(({ title, align = "left" }, idx) => (
            <TableCell key={idx} align={align} className={classnames({ [classes.fixedHeader]: fixedHeader })}>
              {title}
            </TableCell>
          ))}
          <TableCell align="center" className={classnames({ [classes.fixedHeader]: fixedHeader })}>
            {type === "shrinkage" ? "Roll Info" : "Wastage"}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {groupOptions.map((option, optionIdx) => {
          return option.groupList.map((group, rowIdx) => {
            return (
              <TableRow key={`${optionIdx}-${rowIdx}`}>
                {rowIdx === 0 && (
                  <TableCell align="center" rowSpan={option.groupList.length}>
                    <Radio checked={option.selected} onChange={() => handleSelection(type, optionIdx)} />
                  </TableCell>
                )}
                <TableCell align="center">{rowIdx + 1}</TableCell>
                {columns.map(({ dataKey, align = "left" }, colIdx) => {
                  return (
                    <TableCell
                      key={colIdx}
                      align={align}
                      className={classnames({ [classes.link]: dataKey === "deviations" })}
                      onClick={() => (dataKey === "deviations" ? onDeviationClick({ record: group }) : null)}>
                      {group[dataKey]}
                    </TableCell>
                  );
                })}

                {rowIdx === 0 && (
                  <TableCell align="center" rowSpan={option.groupList.length}>
                    <div>
                      {type === "shrinkage" ? (
                        <ImageEye onClick={() => onViewClick(option.groupList)} />
                      ) : (
                        `${toFixed(option.widthWasteLength, 1)} m (${toFixed(option.widthWastePercent, 2)}%)`
                      )}
                    </div>
                  </TableCell>
                )}
              </TableRow>
            );
          });
        })}
      </TableBody>
    </MuiTable>
  );
};

GroupOptionsTable.propTypes = {
  fixedHeader: PropTypes.bool,
  type: PropTypes.oneOf(["shrinkage", "final"]),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dataKey: PropTypes.string,
      title: PropTypes.string,
      align: PropTypes.oneOf(["left", "right", "center"]),
      element: PropTypes.element,
      selectAll: PropTypes.bool
    })
  ),
  groupOptions: PropTypes.arrayOf(PropTypes.object),
  onDeviationClick: PropTypes.func,
  onViewClick: PropTypes.func
};

GroupOptionsTable.defaultProps = {
  fixedHeader: true,
  id: "table",
  handleSelection: () => {},
  onDeviationClick: () => {},
  onViewClick: () => () => {}
};

export default GroupOptionsTable;
